import React from 'react';

const TYPE_ICON_CLS = {
  red: 'text-red-600 bg-red-50',
  green: 'text-green-600 bg-green-50',
  amber: 'text-orange-600 bg-orange-50',
  blue: 'text-blue-600 bg-blue-50',
  '': 'text-seha-500 bg-blue-50',
};

export default function KpiCard({ label, value, note, icon: Icon, type = '' }) {
  const kpiTypeCls = type ? `kpi-${type}` : '';
  return (
    <div className={`kpi-card ${kpiTypeCls} bg-white p-6 rounded-xl border border-neutral-200 shadow-subtle hover:shadow-card transition-shadow`}>
      <div className="flex justify-between items-start">
        <div>
          <p className="kpi-label">{label}</p>
          <h3 className="kpi-value">{value}</h3>
        </div>
        {Icon && (
          <div className={`p-2.5 rounded-lg ${TYPE_ICON_CLS[type] || TYPE_ICON_CLS['']}`}>
            <Icon className="w-6 h-6" />
          </div>
        )}
      </div>
      {note && <p className="kpi-note">{note}</p>}
    </div>
  );
}
